import { render, staticRenderFns } from "./PageWrapperCommon.vue?vue&type=template&id=f68d2a2e&scoped=true&"
import script from "./PageWrapperCommon.vue?vue&type=script&lang=js&"
export * from "./PageWrapperCommon.vue?vue&type=script&lang=js&"
import style0 from "./PageWrapperCommon.vue?vue&type=style&index=0&id=f68d2a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68d2a2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
